export const labelsGaNames = {
  PIM: 'onlineOnly',
  BPR: 'bestPrice',
  LOF: 'offerLimited',
  STD: 'discount',
  WIZ: null,
};

export const viewRRTracking = (impressionContentId: string) => {
  if (!window.rrApiOnReady) window.rrApiOnReady = [];

  window.rrApiOnReady.push(() => {
    try {
      window?.rrApi?.impressionContentViewed({
        impressionContentId,
      });
    } catch (e) {
      /* */
    }
  });
};

export const clickRRTracking = (impressionContentId: string) => {
  if (!window.rrApiOnReady) window.rrApiOnReady = [];

  window.rrApiOnReady.push(() => {
    try {
      window?.rrApi?.impressionContentClicked({
        impressionContentId,
      });
    } catch (e) {
      /* */
    }
  });
};
